<template>
	<a-modal
		:title="isUpdate ? '修改文章' : '新增文章'"
		:width="960"
		:visible="visible"
		:confirmLoading="loading"
		:maskClosable="false"
		@ok="handleOk"
		@cancel="handleCancel"
	>
		<a-spin :spinning="loading">
			<a-form-model
				ref="adminForm"
				:model="form"
				:label-col="{ span: 3 }"
				:wrapper-col="{ span: 19 }"
				autoComplete="off"
			>
				<a-form-model-item
					label="标题"
					prop="title"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'blur' }]"
				>
					<a-input v-model="form.title" :maxLength="100" placeholder="请输入标题" />
				</a-form-model-item>

				<a-form-model-item
					label="内容"
					prop="content"
					:rules="[{ required: true, message: '必填，不能为空', trigger: 'change' }]"
				>
					<div style="line-height: normal;">
						<quill-editor
							ref="quillEditor"
							v-model="content"
							:options="editorOption"
							@ready="onEditorReady"
							@change="onEditorChange"
						/>
					</div>
					<a-textarea v-show="false" v-model="form.content" />
				</a-form-model-item>

				<a-form-model-item label="摘要" prop="summary">
					<a-textarea
						v-model="form.summary"
						:auto-size="{ minRows: 3, maxRows: 5 }"
						placeholder="不填则根据正文自动生成"
					/>
				</a-form-model-item>
			</a-form-model>
		</a-spin>
	</a-modal>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import '@/assets/quill/quill.zh.css';
import quillOption, { bindQuillPasteImage } from '@/assets/quill/quill.config';

function emptyForm() {
	return {
		id: 0,
		title: '',
		content: '',
		summary: ''
	};
}

export default {
	components: {
		quillEditor
	},
	props: {
		visible: {
			type: Boolean,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			form: emptyForm(),
			content: '',
			editorOption: quillOption
		};
	},
	computed: {
		isUpdate() {
			return this.form.id > 0;
		}
	},
	watch: {
		visible(val) {
			if (!val) {
				this.initForm();
			}
		}
	},
	methods: {
		onEditorReady(quill) {
			bindQuillPasteImage(quill);
		},
		initForm() {
			this.form = emptyForm();
			this.content = '';
			this.$nextTick(() => {
				if (this.$refs.adminForm) {
					this.$refs.adminForm.clearValidate();
				}
			});
		},
		setForm(data) {
			this.form = {
				...emptyForm(),
				id: data.id || 0,
				title: data.title || '',
				content: data.content || '',
				summary: data.summary || ''
			};
			this.content = data.content || '';
			this.$nextTick(() => {
				if (this.$refs.adminForm) {
					this.$refs.adminForm.clearValidate();
				}
			});
		},
		onEditorChange() {
			this.form.content = this.content;
		},
		handleOk() {
			this.$emit('ok');
		},
		handleCancel() {
			this.$emit('cancel');
		},
		validate(callback) {
			this.form.content = this.content;
			this.$refs.adminForm.validate(valid => {
				callback(valid, { ...this.form });
			});
		}
	}
};
</script>

<style scoped>
</style>
